export default {
  data() {
    return {
      localizedOccupations: [
        {
          key: "Full time employment",
          value: "message.occupationFullTime"
        },
        {
          key: "Part time employment",
          value: "message.occupationPartTime "
        },
        {
          key: "Retired",
          value: "message.occupationRetired"
        },
        {
          key: "Self-employed",
          value: "message.occupationSelfEmployed",
        },
        {
          key: "Student",
          value: "message.occupationStudent"
        },
        {
          key: "Unemployed",
          value: "message.occupationUnemployed"
        },
        {
          key: "Prefer not to say",
          value: "message.occupationPreferNotToSay"
        }

      ]
    }
  },
  methods: {
    localizeOccupation(key) {
      let self = this;
      let localizedOccupation = self.localizedOccupations.filter(function (item) {
        return item.key === key;
      });
      if (localizedOccupation.length > 0) {
        return self.$t(localizedOccupation[0].value);
      }
      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Occupations/index.js